/** App mark: a raindrop over a draining basin. */
export function BrandMark({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" role="img" aria-label="BMP Hydrology Calculator 2.0">
      <rect width="48" height="48" rx="12" fill="var(--mantine-primary-color-filled)" />
      <path d="M24 8c5 7 9 11.5 9 16.5A9 9 0 0 1 15 24.5C15 19.5 19 15 24 8Z" fill="#fff" />
      <path d="M9 34c4 0 4 3 7.5 3S20 34 24 34s4 3 7.5 3 3.5-3 7.5-3" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" opacity=".85" />
    </svg>
  );
}
